<script setup>
import Vue, {reactive, ref} from "vue";
import needsService from "@/services/ecosystem/needs.service";
import {inject} from "vue";
// import {getLogo} from "@/helpers/logo";
import Button from "@/components/ui/Button.vue";
import useForm from "@/composables/useForm";
import {triggerUpsell} from "@/composables/useStoreActions";
import {useStore} from "vue2-helpers/vuex";

const store = useStore();
const emit = defineEmits(['submitted', 'showUpsell']);

const need = inject('need');
const showModal = ref(false);
const startupId = ref(null);
const startup = ref(null);
const loading = ref(false);

const form = reactive({
    note: '',
});

const {resetForm} = useForm(form);

async function getStartupInfo() {
    const {data} = await needsService.getStartupInfo(need.value.id, startupId.value);

    if (data === 'limit-exceeded') {
        triggerUpsell(store);
        return;
    }

    startup.value = data;
    showModal.value = true;
}

async function submitStartup() {
    loading.value = true;
    const {data: message} = await needsService.submitStartup(need.value.id, startupId.value, form);

    loading.value = false;
    showModal.value = false;

    if (message.length) {
        Vue.notify({
            group: 'app',
            type: 'error',
            duration: 5000,
            text: message
        });
    } else {
        Vue.notify({
            group: 'app',
            type: 'success',
            duration: 5000,
            text: 'Startup submitted'
        });

        emit("submitted");
    }
}

function open(id) {
    resetForm();
    startup.value = null;
    startupId.value = id;

    getStartupInfo();
}

defineExpose({
    open
});
</script>

<template>
    <Modal v-model="showModal" :title="startup ? `Submit ${startup.name} To This Need` : ''" modal-class="modal-v2 modal-v2--lg modal-submit">
        <div class="modal-submit__content">
            <div class="modal-submit__aside">
                <div>
                    <!--div class="data-labels-set">
                        <span class="data-label">
                            <img :src="getLogo(startup?.logo)"/>
                        </span>
                    </div-->
                    <h6 class="heading6">
                        <a :href="`/startups/${startup?.id}`" target="_blank">{{startup?.name}}</a>
                    </h6>
                </div>

                <div class="match-rate-wrapper">
                    <span v-if="startup?.score" class="match-rate match-rate--high match-rate--lg match-rate--bordered">{{startup.score}}% match</span>
                </div>

                <div v-if="startup?.categories.length" class="status-plate-wrapper">
                    <span
                        v-for="category in startup.categories"
                        :key="category"
                        class="status-plate status-plate--unreviewed status-plate--lg status-plate--bordered"
                    >
                        {{category}}
                    </span>
                </div>
            </div>
            <div>
                <h6 class="heading6 heading6--upper">Submission note <small class="heading6__sub">(Recommended)</small></h6>

                <div class="note-lightning">
                    <div class="note-lightning__inner">
                        <p>Add a note explaining why this startup is a good fit for this enterprise to strengthen your introduction. Try including:</p>

                        <ul class="list-check list-check--cols">
                            <li>Recent traction (new clients, pilots, revenue growth)</li>
                            <li>Strategic shifts (pivots, new markets)</li>
                            <li>Upcoming milestones (fundraising, product launches)</li>
                            <li>Relevant standout team experience</li>
                        </ul>
                    </div>
                </div>


                <form action="" class="form-v2">
                    <textarea v-model="form.note" class="form-control mb-0" placeholder="Share your perspective on this startup’s value, its key strengths, relevant experiences, or any other context that might be helpful"></textarea>
                </form>
            </div>
        </div>

        <template #modal-footer>
            <Button
                :loading="loading"
                class="btn ui-button ui-button--xxl"
                @click="submitStartup"
            >
                Submit
                <template #loading>
                    Submitting...
                </template>
            </Button>
        </template>
    </Modal>
</template>

<style scoped>

</style>
